import axios from 'axios';
import { GET_LINE_OPTIC_HIGHWAY_API_URL, GET_WELL_HIGHWAY_API_URL, GET_PILLAR_HIGHWAY_API_URL,
  GET_GOUPLING_HIGHWAY_API_URL, GET_FOB_HIGHWAY_API_URL, GET_SUMMIT_HIGHWAY_API_URL,
  GET_EQUIPMENT_CANTON_API_URL, GET_WELL_CANTON_API_URL, GET_PILLAR_CANTON_API_URL,
  GET_COUPLING_CANTON_API_URL, GET_FOB_CANTON_API_URL, GET_LINE_OPTIC_CANTON_API_URL, GET_PON_BOX_CANTON_API_URL,
  GET_HOUSES_POLIGON_API_URL,
  GET_KTV_AMPLIFIER_COORDINATE_API_URL,
  GET_KTV_OP_COORDINATE_API_URL,
  GET_DIVIDER_COORDINATE_API_URL,
  GET_CABLE_PROJECT_CONSTRTUCT_API_URL,
  GET_COUPLING_CONSTRUCTOR_API_URL,
  GET_FOB_CONSTRUCTOR_API_URL,
  GET_PON_BOX_CONSTRUCTOR_API_URL,
  GET_CABLE_SINGLE_REFRESH_CONSTRUCTION_API_URL,
  GET_CABLE_BY_ID_PROJECT_CONSTRTUCT_API_URL,
  GET_HOUSES_POLIGON_CONSTRUCTION_API_URL,
  GET_WIFI_POINT_LOCATION_API_URL,
  GET_WIFI_POINT_BY_ID_LOCATION_API_URL} from '../../Optics/OpticApiConfig';
import { radiusWell, radiusPillar, CONST_HIGHWAY, CONST_CANTON } from '../../Optics/Constants/ConstantsOptics';

// отображение оптики для карты (параметры опты)
const processLineOpticData = (lineOpticData) => {
    const groupedCoordinatesWithColorTypeAndWidth = lineOpticData.reduce((acc, coordinate) => {
      if (!acc[coordinate.highwayLineId]) {
        acc[coordinate.highwayLineId] = {
          coordinates: [],
          color: coordinate.cableColor,
          type: coordinate.cableTypeKind,
          width: coordinate.cableWidth,
          fiberQuantity: coordinate.cableFiberQuantity,
          activity: coordinate.activity,
          pon: coordinate.pon,
          ktv: coordinate.ktv,
          ether: coordinate.ether,
          cableTypeId: coordinate.cableTypeId,
          rankCableId: coordinate.rankCableId,
          forwardingCount: coordinate.forwardingCount,
          polishingPatchId: coordinate.polishingPatchId,
          polishingType: coordinate.polishingType,
          patchCount: coordinate.patchCount,
          cassetteId: coordinate.cassetteId,
          cassetteModel: coordinate.cassetteModel,
          cassetteCount: coordinate.cassetteCount,

     };
      }
      acc[coordinate.highwayLineId].coordinates.push([coordinate.latitude, coordinate.longitude]);
      return acc;
    }, {});
    return groupedCoordinatesWithColorTypeAndWidth;
  };

  // формируем Territory для кабеля
  function generateTerritoryByHighwayLineId(data) {
    const territoryByHighwayLineId = {};
  
    // Группируем данные по highwayLineId, canton и region
    const groupedByCanton = data.reduce((acc, item) => {
      const { highwayLineId, canton, region, area } = item;
  
      // Исключаем элементы, где canton, region или area равны нулю
      if (canton && region && area) {
        if (!acc[highwayLineId]) acc[highwayLineId] = {};
        if (!acc[highwayLineId][canton]) acc[highwayLineId][canton] = {};
        if (!acc[highwayLineId][canton][region]) acc[highwayLineId][canton][region] = new Set();
  
        acc[highwayLineId][canton][region].add(area);
      }
  
      return acc;
    }, {});
  
    // Формируем массив territory для каждого highwayLineId
    for (const highwayLineId in groupedByCanton) {
      const cantons = groupedByCanton[highwayLineId];
      const territory = [];
  
      for (const canton in cantons) {
        const regions = cantons[canton];
        const regionArray = [];
  
        for (const region in regions) {
          regionArray.push({
            region,
            areas: Array.from(regions[region]), 
          });
        }
  
        territory.push({
          canton,
          regions: regionArray,
        });
      }
  
      territoryByHighwayLineId[highwayLineId] = territory;
    }
  
    return territoryByHighwayLineId;
  }

  

// отображение проекта
    export const GetCantonPoligonWifi = async ( selectedRegion, selectedArea, selectedCanton, setCouplingLocationData, setWifiPointLocationData,
      setGroupedCoordinatesWithColorTypeAndWidth, setPosition, setStatusModalTerritory, setDescriptionOptic,
       setPonBoxLocationData, setHousesData, setSwitches, setLoadingCunton ) => {

    
      // Сбрасываем данные
      setHousesData([]);
      setPonBoxLocationData([]);
      setCouplingLocationData([]);
      setWifiPointLocationData([]);
      setSwitches([]);
      setGroupedCoordinatesWithColorTypeAndWidth([]);
      setLoadingCunton(true);
    
    
      const token = localStorage.getItem('token');
    
      try {

        // Параллельные запросы для других данных
        const apiUrls = {
          housesPoligon: `${GET_HOUSES_POLIGON_CONSTRUCTION_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`,
          wifiLocation: `${GET_WIFI_POINT_LOCATION_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`,
          // couplingLocation: `${GET_COUPLING_CONSTRUCTOR_API_URL}?projectId=${projectId}`,
          // fobLocation: `${GET_FOB_CONSTRUCTOR_API_URL}?projectId=${projectId}`,
          // ponBoxLocation: `${GET_PON_BOX_CONSTRUCTOR_API_URL}?projectId=${projectId}`,
          // lineOptic: `${GET_CABLE_PROJECT_CONSTRTUCT_API_URL}?projectId=${projectId}`,
        };
    
        // Параллельные запросы
        const [
          resultHousesPoligon,
          resultWifiLocation,
           
        ] = await Promise.all([
          axios.get(apiUrls.housesPoligon, { headers: { 'Authorization': `Bearer ${token}` } }),
          axios.get(apiUrls.wifiLocation, { headers: { 'Authorization': `Bearer ${token}` } }),
        
        ]);

          let latitude, longitude;

          if (Array.isArray(resultHousesPoligon?.data) && resultHousesPoligon.data.length > 0) {
            const firstPoint = resultHousesPoligon.data[0];

            latitude = firstPoint.latitude;
            longitude = firstPoint.longitude;

            if (latitude !== undefined && longitude !== undefined) {
              setPosition([latitude, longitude]);
            }
          }

            
        // Устанавливаем полученные данные
        setHousesData(resultHousesPoligon.data);
        setWifiPointLocationData(resultWifiLocation.data.wifiList);
        setSwitches(resultWifiLocation.data.combined);
        // setCouplingLocationData(resultCouplingLocation.data);
        
        // setPonBoxLocationData(resultPonBoxLocation.data);
       
        // const uniqueData = resultLineOptic.data.listLineOpticCoordinate.filter(
        //   (item, index, self) => index === self.findIndex(t => t.id === item.id)
        // );
    
        // const territoryByHighwayLineId = generateTerritoryByHighwayLineId(resultLineOptic.data.listLineOpticCoordinate);
    
        // const updatedUniqueData = uniqueData.map(item => ({
        //   ...item,
        //   territory: territoryByHighwayLineId[item.highwayLineId] || [],
        // }));
    
        
        // const processedData = processLineOpticData(resultLineOptic.data.listLineOpticCoordinate);
        // setGroupedCoordinatesWithColorTypeAndWidth(processedData);
        // setDescriptionOptic(updatedUniqueData);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
         setLoadingCunton(false);
      }
    };

// OLD отображение территории из фильтра (Округ / Регион / Ветка)
// export const GetCantonFilter = async ( selectedRegionRef, selectedAreaRef, selectedCanton, 
//             setSwitchesData, setWellData, setPillarData, setCouplingLocationData, setFobLocationData,
//             setGroupedCoordinatesWithColorTypeAndWidth, setLoadingCunton, setPosition,setStatusModalTerritory,
//             setDescriptionOptic, setPonBoxLocationData, setHousesData) => {  

//       const selectedRegion = selectedRegionRef.current.value;
    
//       const selectedArea = selectedAreaRef.current.value;
//       setSwitchesData([]);
//       setHousesData([]);
//       setWellData([]);
//       setPillarData([]);
//       setPonBoxLocationData([]);
//       setCouplingLocationData([]);
//       setFobLocationData([]);
//       setGroupedCoordinatesWithColorTypeAndWidth([]);
//       setLoadingCunton(true);
      
//       try {
//         if (selectedCanton === "null") {
//          // console.error("Выберите округ!");
//           return;
//         }
//         const token = localStorage.getItem('token');

//         let apiUrlEquipment = `${GET_EQUIPMENT_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`;

//       //  let apiUrlHouses = `${GET_HOUSES_POLIGON_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`;
         
//         const resultEquipment = await axios.get(apiUrlEquipment, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });  
        
//         // const resultHouses = await axios.get(apiUrlHouses, {
//         //   headers:{
//         //     'Authorization': `Bearer ${token}` 
//         //   }
//         // }); 
//         // setHousesData(resultHouses.data);  

//         const { latitude, longitude } = resultEquipment.data[0];
//         setPosition([latitude, longitude]);
//         setSwitchesData(resultEquipment.data);
//         setStatusModalTerritory('canton');

//          let apiUrlWell = `${GET_WELL_CANTON_API_URL}?radius=${radiusWell}&centerLat=${latitude}&centerLon=${longitude}`;
      
//          let apiUrlPillar = `${GET_PILLAR_CANTON_API_URL}?radius=${radiusPillar}&centerLat=${latitude}&centerLon=${longitude}`;

//          let apiUrlCouplingLocation = `${GET_COUPLING_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`;

//          let apiUrlFobLocation = `${GET_FOB_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`;

//          let apiUrlPonBoxLocation = `${GET_PON_BOX_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`;

//          let apiUrlLineOptic = `${GET_LINE_OPTIC_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`;

//         const resultWell = await axios.get(apiUrlWell, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setWellData(resultWell.data);

//         const resultPillar  = await axios.get(apiUrlPillar, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setPillarData(resultPillar.data);

//         const resultCouplingLocation  = await axios.get(apiUrlCouplingLocation, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setCouplingLocationData(resultCouplingLocation.data);

//         const resultFobLocation  = await axios.get(apiUrlFobLocation, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setFobLocationData(resultFobLocation.data);

//         const resultPonBoxLocation  = await axios.get(apiUrlPonBoxLocation, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setPonBoxLocationData(resultPonBoxLocation.data);

//         try {
//           const resultLineOptic = await axios.get(apiUrlLineOptic, {
//             headers:{
//               'Authorization': `Bearer ${token}` 
//             }
//           });
         
//           const uniqueData = resultLineOptic.data.filter((item, index, self) =>
//             index === self.findIndex((t) => t.id === item.id)
//           );
//           const territoryByHighwayLineId = generateTerritoryByHighwayLineId(resultLineOptic.data);
        
//          // Добавляем territory к uniqueData
//           const updatedUniqueData = uniqueData.map((item) => {
//             const territory = territoryByHighwayLineId[item.highwayLineId] || []; 
//             return { ...item, territory }; 
//           });

//           const processedData = processLineOpticData(resultLineOptic.data); 
//           setGroupedCoordinatesWithColorTypeAndWidth(processedData);
//           //setDescriptionOptic(uniqueData);
//           setDescriptionOptic(updatedUniqueData);
//         } catch (error) {
//           //console.error("Error fetching LineOptic data:", error);
//         }
//       } catch (error) {
//        // console.error("Error fetching data:", error);
//       } finally {
//         setLoadingCunton(false);
//       }
//     }

//NEW отображение территории из фильтра (Округ / Регион / Ветка)  второй метод для перерисовки во внесении DrawerCanton
export const GetCantonFilterRefresh = async (selectedRegoin, selectedArea, selectedCanton, setSwitchesData, setWellData, setPillarData, 
  setCouplingLocationData, setFobLocationData, setGroupedCoordinatesWithColorTypeAndWidth, setLoadingCunton, setPosition, setStatusModalTerritory, 
  setDescriptionOptic, setPonBoxLocationData, setProblemCableData, setDividerData) => {

  setSwitchesData([]);
  setWellData([]);
  setPillarData([]);
  setCouplingLocationData([]);
  setFobLocationData([]);
  setPonBoxLocationData([]);
  setGroupedCoordinatesWithColorTypeAndWidth([]);
  setLoadingCunton(true);
  setProblemCableData([]);
  setDividerData([]);

  if (selectedCanton === "null") {
    // console.error("Выберите округ!");
    return;
  }

  const token = localStorage.getItem('token');
  const headers = { 'Authorization': `Bearer ${token}` };
  
  const apiUrls = {
    equipment: `${GET_EQUIPMENT_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`,
    well: `${GET_WELL_CANTON_API_URL}?radius=${radiusWell}&centerLat={latitude}&centerLon={longitude}`,
    pillar: `${GET_PILLAR_CANTON_API_URL}?radius=${radiusPillar}&centerLat={latitude}&centerLon={longitude}`,
    coupling: `${GET_COUPLING_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`,
    fob: `${GET_FOB_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`,
    lineOptic: `${GET_LINE_OPTIC_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`,
    ponBox: `${GET_PON_BOX_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`,
    divider: `${GET_DIVIDER_COORDINATE_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`,
  };

  try {

    const resultEquipment = await axios.get(apiUrls.equipment, { headers });
    const { latitude, longitude } = resultEquipment.data[0];

    setSwitchesData(resultEquipment.data);
    setStatusModalTerritory(CONST_CANTON);

    // Создание массива запросов
    const apiRequests = [
      axios.get(apiUrls.well.replace('{latitude}', latitude).replace('{longitude}', longitude), { headers }),
      axios.get(apiUrls.pillar.replace('{latitude}', latitude).replace('{longitude}', longitude), { headers }),
      axios.get(apiUrls.coupling, { headers }),
      axios.get(apiUrls.fob, { headers }),
      axios.get(apiUrls.ponBox, { headers }),
      axios.get(apiUrls.lineOptic, { headers }),
      axios.get(apiUrls.divider, { headers}),
    ];

    const [
      resultWell,
      resultPillar,
      resultCouplingLocation,
      resultFobLocation,
      resultPonBoxLocation,
      resultLineOptic,
      resultDivider,
    ] = await Promise.all(apiRequests);

    setWellData(resultWell.data);
    setPillarData(resultPillar.data);
    setCouplingLocationData(resultCouplingLocation.data);
    setFobLocationData(resultFobLocation.data);
    setPonBoxLocationData(resultPonBoxLocation.data);
    setDividerData(resultDivider.data);
   

    const uniqueData = resultLineOptic.data.listLineOpticCoordinate.filter(
      (item, index, self) => index === self.findIndex(t => t.id === item.id)
    );

    const territoryByHighwayLineId = generateTerritoryByHighwayLineId(resultLineOptic.data.listLineOpticCoordinate);

    // Добавление territory к uniqueData
    const updatedUniqueData = uniqueData.map((item) => {
      const territory = territoryByHighwayLineId[item.highwayLineId] || []; 
      return { ...item, territory }; 
    });

    const processedData = processLineOpticData(resultLineOptic.data.listLineOpticCoordinate); 
    setGroupedCoordinatesWithColorTypeAndWidth(processedData);
    setDescriptionOptic(updatedUniqueData);
    setProblemCableData(resultLineOptic.data.problemLines);

  } catch (error) {
    // console.error("Error fetching data:", error);
  } finally {
    setLoadingCunton(false);
  }
};

//OLD отображение территории из фильтра (Округ / Регион / Ветка)  второй метод для перерисовки во внесении DrawerCanton
// export const GetCantonFilterRefresh = async ( selectedRegoin, selectedArea, selectedCanton,
//             setSwitchesData, setWellData, setPillarData, setCouplingLocationData, setFobLocationData,
//             setGroupedCoordinatesWithColorTypeAndWidth, setLoadingCunton, setPosition,setStatusModalTerritory,setDescriptionOptic, setPonBoxLocationData, setHousesData) => {  

//       setSwitchesData([]);
//       setHousesData([]);
//       setWellData([]);
//       setPillarData([]);
//       setCouplingLocationData([]);
//       setFobLocationData([]);
//       setGroupedCoordinatesWithColorTypeAndWidth([]);
//       setLoadingCunton(true);
      
//       try {
       
//         if (selectedCanton === "null") {
//          // console.error("Выберите округ!");
//           return;
//         }
//         const token = localStorage.getItem('token');

//         let apiUrlEquipment = `${GET_EQUIPMENT_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`;

//         //let apiUrlHouses = `${GET_HOUSES_POLIGON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`;

//         const resultEquipment = await axios.get(apiUrlEquipment, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });   
//         const { latitude, longitude } = resultEquipment.data[0];
//        // setPosition([latitude, longitude]);  
//         setSwitchesData(resultEquipment.data);
//         setStatusModalTerritory('canton');


//         // const resultHouses = await axios.get(apiUrlHouses, {
//         //   headers:{
//         //     'Authorization': `Bearer ${token}` 
//         //   }
//         // }); 
//         // setHousesData(resultHouses.data);  
        
//         let apiUrlWell = `${GET_WELL_CANTON_API_URL}?radius=${radiusWell}&centerLat=${latitude}&centerLon=${longitude}`;
      
//         let apiUrlPillar = `${GET_PILLAR_CANTON_API_URL}?radius=${radiusPillar}&centerLat=${latitude}&centerLon=${longitude}`;

//         let apiUrlCouplingLocation = `${GET_COUPLING_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`;

//         let apiUrlFobLocation = `${GET_FOB_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`;

//         let apiUrlLineOptic = `${GET_LINE_OPTIC_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`;

//         let apiUrlPonBoxLocation = `${GET_PON_BOX_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`;

//         const resultWell = await axios.get(apiUrlWell, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setWellData(resultWell.data);

//         const resultPillar  = await axios.get(apiUrlPillar, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setPillarData(resultPillar.data);

//         const resultCouplingLocation  = await axios.get(apiUrlCouplingLocation, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setCouplingLocationData(resultCouplingLocation.data);

//         const resultFobLocation  = await axios.get(apiUrlFobLocation, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setFobLocationData(resultFobLocation.data);

//         const resultPonBoxLocation  = await axios.get(apiUrlPonBoxLocation, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setPonBoxLocationData(resultPonBoxLocation.data);

//         try {
//           const resultLineOptic = await axios.get(apiUrlLineOptic, {
//             headers:{
//               'Authorization': `Bearer ${token}` 
//             }
//           });

//           const uniqueData = resultLineOptic.data.filter((item, index, self) =>
//             index === self.findIndex((t) => t.id === item.id)
//           );

//           const territoryByHighwayLineId = generateTerritoryByHighwayLineId(resultLineOptic.data);
        
//           // Добавляем territory к uniqueData
//            const updatedUniqueData = uniqueData.map((item) => {
//              const territory = territoryByHighwayLineId[item.highwayLineId] || []; 
//              return { ...item, territory }; 
//            });

//           const processedData = processLineOpticData(resultLineOptic.data); 
//           setGroupedCoordinatesWithColorTypeAndWidth(processedData);
//           //setDescriptionOptic(uniqueData);
//           setDescriptionOptic(updatedUniqueData);

          
//         } catch (error) {
//           //console.error("Error fetching LineOptic data:", error);
//         }
//       } catch (error) {
//        // console.error("Error fetching data:", error);
//       } finally {
//         setLoadingCunton(false);
//       }
//     }

// NEW отображение территории из фильтра (Город / Страна) REFRESH
export const GetHighwayFilterRefresh = async (setSwitchesData, setWellData, setPillarData, setCouplingLocationData, setFobLocationData, setGroupedCoordinatesWithColorTypeAndWidth, 
  setLoadingSummit, selectedCity, setPosition, setStatusModalTerritory, setDescriptionOptic, setProblemCableData, handleLineClearMap ) => {  
    
  setSwitchesData([]);
  setWellData([]);
  setPillarData([]);
  setCouplingLocationData([]);
  setFobLocationData([]);
  setGroupedCoordinatesWithColorTypeAndWidth([]);
  setLoadingSummit(true);
  setProblemCableData([]);

  if (selectedCity === "null") {
    // console.error("Выберите город!");
    return;
  }

  const token = localStorage.getItem('token');
  const headers = { 'Authorization': `Bearer ${token}` };
  
  const apiUrls = {
    lineOpticHighway: `${GET_LINE_OPTIC_HIGHWAY_API_URL}?city=${selectedCity}`,
    wellHighway: `${GET_WELL_HIGHWAY_API_URL}?city=${selectedCity}`,
    pillarHighway: `${GET_PILLAR_HIGHWAY_API_URL}?city=${selectedCity}`,
    couplingHighway: `${GET_GOUPLING_HIGHWAY_API_URL}?city=${selectedCity}`,
    fobHighway: `${GET_FOB_HIGHWAY_API_URL}?city=${selectedCity}`,
    summitCoordinate: `${GET_SUMMIT_HIGHWAY_API_URL}?city=${selectedCity}`,
  };

  try {
    await handleLineClearMap();

    // Параллельное выполнение всех запросов
    const [
      resultSummitCoordinate,
      resultWellHighway,
      resultPillarHighway,
      resultCouplingHighway,
      resultFobHighway,
      resultLineOpticHighway
    ] = await Promise.all([
      axios.get(apiUrls.summitCoordinate, { headers }),
      axios.get(apiUrls.wellHighway, { headers }),
      axios.get(apiUrls.pillarHighway, { headers }),
      axios.get(apiUrls.couplingHighway, { headers }),
      axios.get(apiUrls.fobHighway, { headers }),
      axios.get(apiUrls.lineOpticHighway, { headers })
    ]);

    const { latitude, longitude } = resultSummitCoordinate.data[0];

    // Обновление состояния
    setSwitchesData(resultSummitCoordinate.data);
    setStatusModalTerritory(CONST_HIGHWAY);

    setWellData(resultWellHighway.data);
    setPillarData(resultPillarHighway.data);
    setCouplingLocationData(resultCouplingHighway.data);
    setFobLocationData(resultFobHighway.data);
    setProblemCableData(resultLineOpticHighway.data.problemLines);
       
    const uniqueData = resultLineOpticHighway.data.listLineOpticHighwayCoordinate.filter(
      (item, index, self) => index === self.findIndex(t => t.id === item.id)
    );
  
    const processedData = processLineOpticData(resultLineOpticHighway.data.listLineOpticHighwayCoordinate); 
    setGroupedCoordinatesWithColorTypeAndWidth(processedData);
    setDescriptionOptic(uniqueData);

  } catch (error) {
    // console.error("Error fetching data:", error);
  } finally {
    setLoadingSummit(false);
  }
};

// OLD отображение территории из фильтра (Город / Страна) REFRESH
// export const GetHighwayFilterRefresh = async (setSwitchesData, setWellData, setPillarData, setCouplingLocationData, 
//   setFobLocationData, setGroupedCoordinatesWithColorTypeAndWidth, setLoadingSummit, selectedCity, setPosition, setStatusModalTerritory,setDescriptionOptic) => {  

// setSwitchesData([]);
// setWellData([]);
// setPillarData([]);
// setCouplingLocationData([]);
// setFobLocationData([]);
// setGroupedCoordinatesWithColorTypeAndWidth([]);
// setLoadingSummit(true);

// try {
//   if (selectedCity === "null") {
//    // console.error("Выберите город!");
//     return;
//   }
//   const token = localStorage.getItem('token');
     
//   let apiUrlLineOpticHighway = `${GET_LINE_OPTIC_HIGHWAY_API_URL}?city=${selectedCity}`;
  
//   let apiUrlWellHighway = `${GET_WELL_HIGHWAY_API_URL}?city=${selectedCity}`;

//   let apiUrlPillarHighway = `${GET_PILLAR_HIGHWAY_API_URL}?city=${selectedCity}`;

//   let apiUrlCouplingHighway = `${GET_GOUPLING_HIGHWAY_API_URL}?city=${selectedCity}`;

//   let apiUrlFobHighway = `${GET_FOB_HIGHWAY_API_URL}?city=${selectedCity}`;

//   let apiUrlSummitCoordinate = `${GET_SUMMIT_HIGHWAY_API_URL}?city=${selectedCity}`;

//   const resultSummitCoordinate  = await axios.get(apiUrlSummitCoordinate,{
//     headers:{
//       'Authorization': `Bearer ${token}` 
//     }
//   });
//   //
//   const { latitude, longitude } = resultSummitCoordinate.data[0];
//   //setPosition([latitude, longitude]);
//   setSwitchesData(resultSummitCoordinate.data);
//   setStatusModalTerritory('highway');

//   const resultWelllHighway = await axios.get(apiUrlWellHighway, {
//     headers:{
//       'Authorization': `Bearer ${token}` 
//     }
//   });
//   setWellData(resultWelllHighway.data);

//    const resultPillarHighway = await axios.get(apiUrlPillarHighway, {
//     headers:{
//       'Authorization': `Bearer ${token}` 
//     }
//    });
//    setPillarData(resultPillarHighway.data);

//   const resultCouplingHighway = await axios.get(apiUrlCouplingHighway, {
//     headers:{
//       'Authorization': `Bearer ${token}` 
//     }
//   });
//   setCouplingLocationData(resultCouplingHighway.data);

//   const resultFobHighway = await axios.get(apiUrlFobHighway, { 
//     headers:{
//       'Authorization': `Bearer ${token}` 
//   }});
//   setFobLocationData(resultFobHighway.data);

//   try {
//     const resultLineOpticHighway = await axios.get(apiUrlLineOpticHighway, {
//       headers:{
//         'Authorization': `Bearer ${token}` 
//       }
//     });
//     const uniqueData = resultLineOpticHighway.data.filter((item, index, self) =>
//     index === self.findIndex((t) => t.id === item.id)
//   );

//   const processedData = processLineOpticData(resultLineOpticHighway.data); 
//   setGroupedCoordinatesWithColorTypeAndWidth(processedData);
//   setDescriptionOptic(uniqueData);

//   } catch (error) {
//    // console.error("Error fetching LineOptic data:", error);
//   }
// } catch (error) {
//  // console.error("Error fetching data:", error);
// } finally {
//   setLoadingSummit(false);
// }

// }


// Fob Refresh Wifi point
export const GetWifiPointFilterRefresh = async (selectedRegoin, selectedArea, selectedCanton, setWifiPointLocationData, setWifiPointMarkers, setSwitches ) => {  

      setWifiPointLocationData([]);
      setWifiPointMarkers([]);
      setSwitches([]);
      
      try {
       
        if (selectedCanton === "null") {
         // console.error("Выберите округ!");
          return;
        }
        const token = localStorage.getItem('token');

        let apiUrlWifiLocation = `${GET_WIFI_POINT_LOCATION_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`;

        const resultWifiLocation  = await axios.get(apiUrlWifiLocation, {
          headers:{
            'Authorization': `Bearer ${token}` 
          }
        });
        setWifiPointLocationData(resultWifiLocation.data.wifiList);
        setSwitches(resultWifiLocation.data.combined);

      } catch (error) {
      } finally {
      }
    }

 

   // Cable Refresh Canton
export const GetCableFilterRefreshConstructor = async ( setGroupedCoordinatesWithColorTypeAndWidth, setDescriptionOptic,
   handleLineClearMap, projectId) => {  

      try {
       
       
        const token = localStorage.getItem('token');

        let apiUrlLineOptic = `${GET_CABLE_PROJECT_CONSTRTUCT_API_URL}?projectId=${projectId}`;

        await handleLineClearMap();

        try {
          const resultLineOptic = await axios.get(apiUrlLineOptic, {
            headers:{
              'Authorization': `Bearer ${token}` 
            }
          });

          const uniqueData = resultLineOptic.data.listLineOpticCoordinate.filter(
            (item, index, self) => index === self.findIndex(t => t.id === item.id)
          );

          const territoryByHighwayLineId = generateTerritoryByHighwayLineId(resultLineOptic.data.listLineOpticCoordinate);
        
          // Добавляем territory к uniqueData
           const updatedUniqueData = uniqueData.map((item) => {
             const territory = territoryByHighwayLineId[item.highwayLineId] || []; 
             return { ...item, territory }; 
           });

           const processedData = processLineOpticData(resultLineOptic.data.listLineOpticCoordinate); 
          setGroupedCoordinatesWithColorTypeAndWidth(processedData);
          setDescriptionOptic(updatedUniqueData);

        } catch (error) {
        }
      } catch (error) {
      } finally {
      }
    }



//перересовываем одину вайфайку
export const GetWifiPointByIdRefresh = async ( wifiPointId, setWifiPointLocationData) => {
 
   try {
    const token = localStorage.getItem('token');
    const apiUrl = `${GET_WIFI_POINT_BY_ID_LOCATION_API_URL}?id=${wifiPointId}`;

       const result = await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    // ⚡ правильное поле
    const wifiList = result.data.wifiList;

    if (!wifiList) {
      console.error("wifiList не найден");
      return;
    }

    const wifi = wifiList.find(w => w.id === wifiPointId);

    if (!wifi) {
      console.error("WiFi не найден");
      return;
    }

    setWifiPointLocationData(prev => {
      const copy = [...prev];
      const idx = copy.findIndex(item => item.id === wifiPointId);

      if (idx === -1) {
        copy.push(wifi);
      } else {
        copy[idx] = wifi;
      }

      return copy;
    });

  } catch (error) {
    console.error("Ошибка при обновлении WiFi точки:", error);
  }
};